var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDecrease15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 31,
    viewBox: "0 0 46 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5452 21.6879C44.9812 21.1723 44.1058 21.2138 43.5903 21.7778L39.9918 25.7189V7.24198C39.9918 6.28699 39.2167 5.51193 38.2617 5.51193H19.3039C18.3489 5.51193 17.5738 6.28699 17.5738 7.24198V18.1863H3.46009V1.73005C3.46009 0.775061 2.68503 0 1.73005 0C0.775061 0 0 0.775061 0 1.73005V19.9163C0 20.8713 0.775061 21.6464 1.73005 21.6464H19.3039C20.2589 21.6464 21.0339 20.8713 21.0339 19.9163V8.97203H36.5351V25.9957L32.255 21.9301C31.7014 21.4041 30.826 21.4249 30.3 21.9785C29.7741 22.5321 29.7949 23.4075 30.3485 23.9369L36.6839 29.9575C36.9538 30.5665 37.5593 30.9921 38.2652 30.9921C38.279 30.9921 38.2894 30.9886 38.3032 30.9886C38.3102 30.9886 38.3171 30.9886 38.324 30.9886C38.4174 30.9886 38.5109 30.9782 38.6008 30.9609C38.632 30.954 38.6596 30.9436 38.6873 30.9332C38.7461 30.9159 38.8084 30.9021 38.8672 30.8779C39.279 30.7256 39.6146 30.4212 39.8084 30.0302L45.6386 23.6428C46.1542 23.0788 46.1127 22.2034 45.5487 21.6879H45.5452Z",
    fill: "#24C062"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecrease15);
export default __webpack_public_path__ + "static/media/decrease15.93517e1aacfb39a5c0ffa21853be9af6.svg";
export { ForwardRef as ReactComponent };